export default "__VITE_ASSET__dc843de9__"